'use client';

import styled from 'styled-components';
import { Button, Text, Checkbox } from '@lmn/design-system';

export const SelectorRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const SelectorHeader = styled.div<{ $isOpen?: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  padding: 2px 16px;
  cursor: pointer;
  height: 48px;
  overflow: hidden;
  border: 2px solid ${(p) => (p.$isOpen ? p.theme.commons.colors.gray800 : 'transparent')};
  border-radius: 8px;
  background: ${(p) => p.theme.kallisto.color.background.static.backgroundLayer01};
`;

export const SelectorLabel = styled(Text).attrs({ variant: 'Caption' })`
  grid-area: 1 / 1;
  align-self: start;

  color: ${(p) => p.theme.kallisto.color.text.static.textSecondary};
`;

export const SelectorValue = styled(Text).attrs({ variant: 'Body' })`
  grid-area: 1 / 1;
  align-self: end;

  color: ${(p) => p.theme.kallisto.color.text.static.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectorBody = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: ${(p) => p.theme.kallisto.space.space200};
  border: 1px solid ${(p) => p.theme.kallisto.color.border.static.borderNeutral};
  border-radius: ${(p) => p.theme.kallisto.border.radius.radius200};
  background: ${(p) => p.theme.kallisto.color.background.static.backgroundLayer02};
  box-shadow: ${(p) => p.theme.kallisto.shadow.largeDownShadow};
  overflow: hidden;
`;

export const SelectorBodyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${(p) => p.theme.kallisto.space.space150};
`;

export const SelectorBodyCheckRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(p) => `${p.theme.kallisto.space.space50} ${p.theme.kallisto.space.space50}`};
`;

export const SelectorBodyValue = styled.div`
  padding: 12px 16px;
  flex: 1;
`;

export const SelectorBodyWithGap = styled(SelectorBody)`
  gap: 16px;
`;

export const SelectorBodyInner = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GroupLabel = styled(Text).attrs({ variant: 'Title5' })`
  display: block;
  margin-bottom: 8px;
`;

export const SelectorActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export const SelectorActionButton = styled(Button)`
  width: 50%;
`;

// TODO: Remove in latest versions of DS, the label is already Body by default
export const StyledCheckbox = styled(Checkbox)`
  [class*='Checkbox__LabelText'] {
    ${({ theme }) => theme.kallisto.mixins.font('Body')};
  }
`;
